import { getSupportedExtensions } from "@/store/features/bulkResize/utils/getSupportedExtensions";
import { useDeviceUpload } from "client/hooks/upload/useDeviceUpload";
import { useDragUpload } from "client/hooks/utils/useDragUpload";
import { useToggle } from "client/hooks/utils/useToggle";
import { useRouter } from "next/router";
import { bulkResizeSelector } from "store/features/bulkResize/selectors/bulkResizeSelector";
import { BulkResizeState } from "store/features/bulkResize/types";
import { useAppSelector } from "store/store";
import { BULK_RESIZE_DEVICE_INPUT_ID } from "../../ControlBar/AddImages/AddImages";
import { useAddImages } from "../../ControlBar/AddImages/useAddImages";

export const useNoImage = () => {
    const { images } = useAppSelector(bulkResizeSelector, equalityFn);
    const { isOpen, toggle, onClose: close } = useToggle();
    const { handleFile } = useAddImages();
    const router = useRouter();
    const supportedExtensions = getSupportedExtensions(router.asPath);
    const { isDragging } = useDragUpload(typeof window !== "undefined" ? document.body : null, handleFile, {
        supportedExtensions,
    });
    const { handleClick: handleDeviceInputClick } = useDeviceUpload(
        handleFile,
        { allowMultiple: true, supportedExtensions },
        BULK_RESIZE_DEVICE_INPUT_ID + router.asPath,
    );

    return { images, isOpen, toggle, close, handleFile, isDragging, handleDeviceInputClick };
};

const equalityFn = (left: BulkResizeState, right: BulkResizeState) => {
    if (left.images.length !== right.images.length) return false;

    return true;
};
